import React, { useState, useEffect, useContext } from "react";
import awsconfig from "../../aws-exports";
import Amplify, { I18n, Auth, API } from "aws-amplify";
import { CognitoIdentityServiceProvider, AWSError } from "aws-sdk";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Alert from "react-s-alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import AuthGroupWrapper from "../Auth/AuthGroupWrapper";
import { cognitoApi } from "../../api";

// This is editing the users...

const UserCuration = (props) => {
  const [viewUser, setViewUser] = useState(false);
  const [editUser, setEditUser] = useState(false);
  const [editPassword, setEditPassword] = useState(false);
  const [usersGroups, setUsersGroups] = useState([]);

  const [tempPassword, setTempPassword] = useState("IonSolar123!");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [group, setGroup] = useState("");
  const [admin, setAdmin] = useState("");

  const {
    user,
    getUsersInGroups,
    addUserToGroup,
    userGroup,
    getUsers,
    removeUserFromGroup,
    userGroups,
  } = props;
  const { Attributes } = user;

  const alertNotification = {
    position: "top-right",
    effect: "flip",
    beep: false,
    timeout: 50000,
    offset: 100,
    color: "rgba(255, 255, 255, 0.927)",
  };

  let currentUser = {
    username: user.email,
    firstName: user.given_name,
    lastName: user.family_name,
    email: user.email,
  };

  useEffect(() => {
    setFirstName(currentUser.firstName);
    setLastName(currentUser.lastName);
    setEmail(currentUser.email);
  }, [editUser]);

  // console.log(Attributes)

  const getGroups = () => {
    cognitoApi.getUserGroups({ username: user.email }).then((res) => {
      setUsersGroups(res.data);
    });
  };
  const updateUser = () => {
    cognitoApi
      .updateUser({
        username: currentUser.username,
        attributes: [
          {
            Name: "given_name",
            Value: firstName,
          },
          {
            Name: "family_name",
            Value: lastName,
          },
          {
            Name: "email",
            Value: email,
          },
        ],
      })
      .then((res) => {
        Alert.success(
          `${firstName} ${lastName} has been updated`,
          alertNotification
        );
        if (difference.length > 0) {
          usersGroups.forEach((group) => {
            removeUserFromGroup(currentUser.username, group.GroupName);
          });
          difference.forEach((group) => {
            addUserToGroup(currentUser.username, group);
          });
        }
        getUsersInGroups(userGroup);
      });
  };

  const enableUser = () => {
    cognitoApi.enableUser({ username: currentUser.username }).then((res) => {
      Alert.success(
        `${firstName} ${lastName} has been enabled`,
        alertNotification
      );
      if (userGroup === "All Users") {
        getUsers();
      } else {
        getUsersInGroups(userGroup);
      }
    });
  };

  // const deleteAttribute = () => {
  //   let params = {
  //     UserAttributeNames: ["phone_number_verified"],
  //     UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  //     Username: currentUser.username,
  //   };
  //   const cognito = new CognitoIdentityServiceProvider(currentRegion);
  //   return cognito.adminDeleteUserAttributes(params, (err, data) => {
  //     if (err) {
  //       Alert.error(`${err}`, alertNotification);
  //     } else {
  //       Alert.success(
  //         `${firstName} ${lastName} has been enabled`,
  //         alertNotification
  //       );
  //     }
  //   });
  // };

  const disableUser = () => {
    cognitoApi.disableUser({ username: currentUser.username }).then((res) => {
      Alert.success(
        `${firstName} ${lastName} has been disabled`,
        alertNotification
      );
      logoutUser(currentUser.username);
      if (userGroup === "All Users") {
        getUsers();
      } else {
        getUsersInGroups(userGroup);
      }
    });
  };

  const logoutUser = (userName) => {
    cognitoApi.globalSignOut({ username: userName }).then((res) => {
      Alert.success(`User Logged Out Globally`, alertNotification);
    });
  };

  const resetPassword = () => {
    cognitoApi
      .resetPassword({
        username: currentUser.username,
        password: tempPassword,
        permanent: false,
      })
      .then((res) => {
        Alert.success(
          `${currentUser.firstName} ${currentUser.lastName} password reset.`,
          alertNotification
        );
      });
  };

  const groups = usersGroups.map((group) => {
    return <span key={group.Precedence}>{group.GroupName} </span>;
  });

  let testGroups = [];

  usersGroups.forEach((element) => {
    testGroups.push(element.GroupName);
  });

  let editGroups = userGroups.filter((element) => testGroups.includes(element));

  // console.log(testGroups, userGroups)

  const finalGroups = [group, admin];

  var difference = finalGroups.filter(function (el) {
    return el !== "";
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    updateUser();
  };

  const handleChangeDept = (event) => {
    setGroup(event.target.value);
  };
  const handleChangeAdmin = (event) => {
    setAdmin(event.target.value);
  };

  useEffect(() => {
    if (group === "Sales-Rep") {
      setAdmin(null);
    }
  }, [group]);

  return (
    <>
      {viewUser ? (
        <>
          <div className="itemsUsersOpen">
            <span onClick={() => setViewUser(!viewUser)}>
              {" "}
              {currentUser.firstName} {currentUser.lastName} - {user.email} -{" "}
              {user.Enabled ? `Active` : `Disabled`}
            </span>
            <span>
              Password Status -{" "}
              {user.UserStatus === "CONFIRMED"
                ? "Current"
                : user.UserStatus === "FORCE_CHANGE_PASSWORD"
                ? "Password Reset"
                : ""}
            </span>
            <span>
              Current Groups -{" "}
              {groups.length > 0 ? (
                <span>{groups}</span>
              ) : (
                <CircularProgress size={20} color="inherit" />
              )}
            </span>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
              }}
            >
              {editGroups.length > 0 ||
              userGroups.includes("Super-Admin") ||
              testGroups.includes("Sales-Rep") ? (
                <>
                  {editGroups.length === 1 && testGroups.includes("Admin") ? (
                    <></>
                  ) : (
                    <>
                      {user.Enabled ? (
                        <button
                          className="buttonDisable"
                          onClick={() => disableUser()}
                        >
                          DISABLE USER
                        </button>
                      ) : (
                        <button className="button" onClick={() => enableUser()}>
                          ENABLE USER
                        </button>
                      )}
                      {editPassword ? (
                        <button onClick={() => setEditPassword(!editPassword)}>
                          CANCEL
                        </button>
                      ) : (
                        <button onClick={() => setEditPassword(!editPassword)}>
                          RESET PASSWORD
                        </button>
                      )}
                      {editUser ? (
                        <button onClick={() => setEditUser(!editUser)}>
                          CANCEL
                        </button>
                      ) : (
                        <button onClick={() => setEditUser(!editUser)}>
                          EDIT USER
                        </button>
                      )}
                    </>
                  )}
                </>
              ) : (
                <></>
              )}
            </div>
            {editPassword ? (
              <>
                <span>
                  {currentUser.firstName} {currentUser.lastName}'s temporary
                  password will be:{" "}
                </span>
                <span>{tempPassword} </span>
                <div>
                  <button onClick={() => resetPassword()}>
                    CONFIRM PASSWORD RESET
                  </button>
                </div>
              </>
            ) : (
              <></>
            )}
            {editUser ? (
              <>
                <form onSubmit={handleSubmit}>
                  <div className="addUser">
                    <div className="addItemUser">
                      <TextField
                        className="input"
                        variant="filled"
                        size="small"
                        margin="dense"
                        label="First Name"
                        onChange={(e) => setFirstName(e.target.value)}
                        helperText={`${currentUser.firstName}`}
                      ></TextField>
                      <TextField
                        className="input"
                        variant="filled"
                        size="small"
                        margin="dense"
                        label="Last Name"
                        onChange={(e) => setLastName(e.target.value)}
                        helperText={`${currentUser.lastName}`}
                      ></TextField>
                      <TextField
                        type="email"
                        className="input"
                        variant="filled"
                        size="small"
                        margin="dense"
                        label="Email"
                        onChange={(e) => setEmail(e.target.value)}
                        helperText={`${currentUser.email}`}
                      ></TextField>
                    </div>
                    <div className="addItemUser1">
                      <FormControl fullWidth component="fieldset">
                        <span>Department: </span>
                        <RadioGroup
                          row
                          aria-label="department"
                          name="department"
                          value={group}
                          onChange={handleChangeDept}
                        >
                          <AuthGroupWrapper
                            requiredGroups={["Super-Admin", "Proposals"]}
                          >
                            <FormControlLabel
                              control={<Radio color="primary" />}
                              type="radio"
                              value="Proposals"
                              name="department"
                              label="Proposals"
                            />
                          </AuthGroupWrapper>
                          <AuthGroupWrapper
                            requiredGroups={["Super-Admin", "Sales-Support"]}
                          >
                            <FormControlLabel
                              control={<Radio color="primary" />}
                              type="radio"
                              value="Sales-Support"
                              name="department"
                              label="Sales Support"
                            />
                          </AuthGroupWrapper>
                        </RadioGroup>
                        <RadioGroup
                          row
                          aria-label="department"
                          name="department"
                          value={group}
                          onChange={handleChangeDept}
                        >
                          <AuthGroupWrapper
                            requiredGroups={["Super-Admin", "Ops"]}
                          >
                            <FormControlLabel
                              control={<Radio color="primary" />}
                              type="radio"
                              value="Ops"
                              name="department"
                              label="Operations"
                            />
                          </AuthGroupWrapper>
                          <AuthGroupWrapper
                            requiredGroups={["Super-Admin", "Sales-Support"]}
                          >
                            <FormControlLabel
                              control={<Radio color="primary" />}
                              type="radio"
                              value="Sales-Rep"
                              name="department"
                              label="Sales Rep"
                            />
                          </AuthGroupWrapper>
                        </RadioGroup>
                      </FormControl>
                      {group ? (
                        <>
                          {group === "Proposals" ? (
                            <>
                              <FormControl fullWidth component="fieldset">
                                <span>User Management </span>
                                <RadioGroup
                                  row
                                  aria-label="admin"
                                  name="admin"
                                  value={admin}
                                  onChange={handleChangeAdmin}
                                >
                                  <FormControlLabel
                                    control={<Radio color="primary" />}
                                    type="radio"
                                    value="Super-Admin"
                                    name="admin"
                                    label="Yes"
                                  />
                                  <FormControlLabel
                                    control={<Radio color="primary" />}
                                    type="radio"
                                    value=""
                                    name="admin"
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </>
                          ) : group === "Sales-Rep" ? (
                            <></>
                          ) : (
                            <FormControl fullWidth component="fieldset">
                              <span>User Management </span>
                              <RadioGroup
                                row
                                aria-label="admin"
                                name="admin"
                                value={admin}
                                onChange={handleChangeAdmin}
                              >
                                <FormControlLabel
                                  control={<Radio color="primary" />}
                                  type="radio"
                                  value="Admin"
                                  name="admin"
                                  label="Yes"
                                />
                                <FormControlLabel
                                  control={<Radio color="primary" />}
                                  type="radio"
                                  value=""
                                  name="admin"
                                  label="No"
                                />
                              </RadioGroup>
                            </FormControl>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <div>
                    <Button
                      style={{
                        color: "rgb(12, 158, 191)",
                        backgroundColor: "rgb(150, 150, 150, .1)",
                        fontSize: "1rem",
                        marginTop: "1rem",
                      }}
                      type="submit"
                    >
                      Confirm Update
                    </Button>
                  </div>
                  <div>
                    <Button
                      onClick={() => setViewUser(!viewUser)}
                      style={{
                        color: "rgb(12, 158, 191)",
                        backgroundColor: "rgb(150, 150, 150, .1)",
                        fontSize: ".8rem",
                        marginTop: ".8rem",
                      }}
                      type="submit"
                    >
                      Cancel
                    </Button>
                  </div>
                </form>
              </>
            ) : (
              <></>
            )}
          </div>
        </>
      ) : (
        <div
          className="itemsUsers"
          onClick={() => {
            setViewUser(!viewUser);
            getGroups();
          }}
        >
          <span>
            {currentUser.firstName} {currentUser.lastName} - {user.email} -{" "}
            {user.Enabled ? `Active` : `Disabled`}
          </span>
        </div>
      )}
    </>
  );
};

export default UserCuration;
